<template>
  <section class="p-close">
    <div class="p-close__header">
      <h2 class="p-close__title"><span class="base">Mantén la</span><span class="hl"> constancia</span></h2>
      <p class="wd-body">La constancia mantiene tus beneficios activos</p>
    </div>

    <div class="p-close__illustration" aria-hidden="true">
      <img class="p-close__illustration-back" :src="dashBack" alt="">
      <img class="p-close__illustration-front" :src="dashFront" alt="">
    </div>

    <div class="p-close__rows">
      <article v-for="row in rows" :key="row.title" class="p-close__row">
        <div class="p-close__row-head">
          <img :src="rowIcon" alt="" aria-hidden="true">
          <p>{{ row.title }}</p>
        </div>
        <p class="p-close__row-body">{{ row.body }}</p>
      </article>
    </div>
  </section>
</template>

<script setup lang="ts">
import dashBack from '../../../assets/pagos-figma/dash-1.svg'
import dashFront from '../../../assets/pagos-figma/dash-2.svg'
import rowIcon from '../../../assets/pagos-figma/icon-constancia.svg'

const rows = [
  {
    title: 'Los pagos tardíos generan impuntualidad',
    body: 'Cada pago fuera de fecha queda registrado en tu historial y puede afectar tu calificación crediticia.'
  },
  {
    title: 'Tus beneficios se reinician',
    body: 'Algunos beneficios no se reinician en caso de generar pagos no puntuales'
  }
]
</script>

<style scoped>
.p-close {
  display: flex;
  flex-direction: column;
  gap: var(--ds-space-5);
  padding: var(--ds-space-5);
  box-sizing: border-box;
  overflow: hidden;
  background: var(--ds-grey-50);
  border-radius: 24px;
}

.p-close__header { display: flex; flex-direction: column; gap: var(--ds-space-3); }
.p-close__title {
  margin: 0;
  color: var(--ds-purple-900);
  font-family: var(--ds-font-family-bebas);
  font-size: 40px;
  font-weight: 700;
  line-height: 44px;
}
.p-close__title .hl { color: #6D59EA; }

/* Ilustración dashboard: caja de 128 con 8 de padding; el SVG frontal es de 112×112 */
.p-close__illustration { position: relative; width: 128px; height: 128px; }
.p-close__illustration-back {
  position: absolute;
  top: 18.5px;
  left: 9.75px;
  width: 98px;
  height: 99.75px;
}
.p-close__illustration-front {
  position: absolute;
  top: 8px;
  left: 8px;
  width: 112px;
  height: 112px;
}

.p-close__rows { display: flex; flex-direction: column; gap: var(--ds-space-5); }
.p-close__row { display: flex; flex-direction: column; gap: var(--ds-space-3); }
.p-close__row-head { display: flex; align-items: center; gap: var(--ds-space-3); min-height: 32px; }
.p-close__row-head img { flex: 0 0 24px; width: 24px; height: 24px; }
.p-close__row-head p {
  margin: 0;
  color: var(--ds-purple-900);
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
}
.p-close__row-body {
  margin: 0;
  color: var(--ds-purple-900);
  font-size: 16px;
  line-height: 24px;
}

@media (max-width: 1024px) {
  .p-close__title { font-size: 32px; line-height: normal; }
}

@media (max-width: 599px) {
  .p-close { padding: var(--ds-space-4); gap: var(--ds-space-5); }
}
</style>
